<template>
  <div class="flex w-full px-2 sm:px-0 flex-col">
    <div class="flex justify-end mb-3 sm:mb-5">
      <button
              @click="back()"
              class=" flex bg-transparent bg-purple_dark sideBackground text-white font-semibold hover:text-white rounded-full px-4 py-4  sm:py-2 sm:rounded-lg">
        <ArrowLeftIcon class="sm:mr-2 self-center" size="1.1x"></ArrowLeftIcon>
        <span class="hidden sm:inline"> Back</span>
      </button>
    </div>
    <div class="flex w-full justify-center">
      <div class="rounded shadow-2xl bg-white flex flex-col sm:p-5 p-3 w-full sm:w-full lg:w-1/2 xl:w-1/3">
        <div class="flex justify-between">
          <p class="text-2xl mb-5 capitalize text-purple_dark font-semibold self-center">
            Edit {{editState.state}} State
          </p>
          <span class=" self-start">
<!--          <Edit3Icon class="text-blue-500" size="2x"></Edit3Icon>-->
        </span>
        </div>
        <div class="w-full">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)" class="">
              <div class="mb-3">
                <label class="block text-left text-md  mb-2">
                  No of Cases
                </label>
                <ValidationProvider rules="numeric|required" v-slot="{errors}">
                  <input class="shadow w-full appearance-none rounded w-64 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                         placeholder="Cases"
                         type="text" v-model="editState.cases">
                  <span class="text-red-dark">{{errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="mb-3">
                <label class="block text-left text-md  mb-2">
                  No of Deaths
                </label>
                <ValidationProvider rules="numeric|required" v-slot="{errors}">
                  <input class="shadow w-full appearance-none rounded w-64 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                         placeholder="Deaths"
                         type="text" v-model="editState.deaths">
                  <span class="text-red-dark">{{errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="mb-3">
                <label class="block text-left text-md  mb-2">
                  No of Recoveries
                </label>
                <ValidationProvider rules="numeric|required" v-slot="{errors}">
                  <input class="shadow w-full appearance-none rounded w-64 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                         placeholder="Survived"
                         type="text" v-model="editState.recovered">
                  <span class="text-red-dark">{{errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="flex items-center justify-between mt-6">
                <button class="bg-purple w-full hover:bg-red-dark-700 text-white  py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="submit">
                  Publish Update
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {ArrowLeftIcon} from 'vue-feather-icons'
  import {db} from "../../db";
  import {eventBus} from "../../eventbus";

  export default {
    name: "StateEdit",
    props: {
      editState: {
        type: Object
      },
      statesWithKey: {
        type: Array,
        required: true
      }
    },
    data: () => ({
      key: ''
    }),
    components: {
      // Edit3Icon,
      ArrowLeftIcon
    },
    methods: {
      onSubmit() {
        db.ref('states/').child(this.key).update({
          cases: 0 - parseInt(this.editState.cases),
          deaths: parseInt(this.editState.deaths),
          recovered: parseInt(this.editState.recovered)
          // eslint-disable-next-line no-unused-vars
        }).then(res => {
          this.$toast.open({
            message: 'Successful',
            type: 'success'
          });
          eventBus.$emit('AllState')
        }).catch(
            // eslint-disable-next-line no-unused-vars
            err => {
              this.$toast.open({
                message: 'Something Went Wrong ' + err,
                type: 'error'
              });
            }
        )
      },
      findKey() {
        let state = this.statesWithKey.find(item => item.state === this.editState.state);
        this.key = state.key

      },
      back() {
        eventBus.$emit('AllState')
      }
    },
    created() {
      this.findKey()
    }
  }
</script>

<style scoped>

</style>
